import styled, { css } from 'styled-components';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useWidgetRect, useWidgetRectRef } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from '../meta';
import { Menu } from './components/menu/Menu';
import { Popup } from './components/popup';

export function Widget() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  const { font } = settings;

  const widgetRectRef = useWidgetRectRef();
  const widgetRect = useWidgetRect();

  return (
    <Deactivation2
      childrenRef={widgetRectRef}
      appAlias={meta.appAlias}
      {...settings}
    >
      <Component _width={Number(widgetRect?.width)}>
        <Container _font={font?.value}>
          <Menu />
        </Container>

        <Popup />

        <FreeLink
          {...freeLinkSettings}
          appAlias={meta.appAlias}
          appName={meta.appName}
          style={{
            link: {
              marginTop: '20px'
            }
          }}
        />
      </Component>
    </Deactivation2>
  );
}

const Component = styled.div.attrs({ className: 'RestaurantMenu__Component' })<{
  _width: number;
}>`
  width: 100%;
  ${({ theme: { colorsStyle } }) => colorsStyle};
  ${({ theme: { colorScheme, backgroundColor }, _width }) =>
    (['light', 'dark'].includes(colorScheme) || !!backgroundColor) &&
    css`
      padding: ${_width <= 400 ? '24px 16px' : '56px 80px'};
    `};
`;

const Container = styled.div.attrs({ className: 'RestaurantMenu__Container' })<{
  _font?: string;
}>`
  max-width: ${({ theme: { widgetWidth } }) =>
    widgetWidth.includes('%')
      ? widgetWidth
      : (widgetWidth.endsWith('px') && widgetWidth) || `${widgetWidth}px`};
  margin: 0 auto;
  ${({ _font }) => _font && `font-family: "${_font}"`};
`;
